import type { ReasonType } from '../../../api/auth/helpers/helpers';

export function getPasswordText(reason: ReasonType | undefined | null): {
    title: string;
    description: string;
} {
    switch (reason) {
        case 'no_password':
            return {
                title: 'Set New Password',
                description: 'Welcome! Please set a password for your account to continue.'
            } as const;

        case 'expired':
            return {
                title: 'Set New Password',
                description: 'Your password has expired. Please set a new password to continue.'
            } as const;
        case 'user_change':
            return {
                title: 'Change Password',
                description: 'You are changing your password. Please enter your new password below.'
            } as const;
        default:
            return { title: 'Change Password', description: 'Enter your new password below.' } as const;
    }
}
